module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Access-to-Services",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.45945946,9.67741935 L15.1327102,9.68904164 L15.1327102,11.6129032 L11.3513514,11.6129032 L11.3513514,15.483871 L9.45945946,15.483871 L9.45945946,9.67741935 Z M58.6486486,9.67741935 L58.6486486,15.4719396 L56.7567568,15.4797954 L56.7567568,11.620759 L52.972973,11.6129032 L52.972973,9.67741935 L58.6486486,9.67741935 Z M18.9189189,9.67741935 L20.8108108,9.67741935 L20.8108108,11.6129032 L18.9189189,11.6129032 L18.9189189,9.67741935 Z M9.45945946,19.3548387 L11.3513514,19.3548387 L11.3513514,25.1612903 L9.45945946,25.1612903 L9.45945946,19.3548387 Z M9.45945946,29.0322581 L11.3513514,29.0322581 L11.3513514,34.8387097 L9.45945946,34.8387097 L9.45945946,29.0322581 Z M58.6486486,29.0322581 L58.6486486,34.8387097 L56.7567568,34.8387097 L56.7567568,29.0322581 L58.6486486,29.0322581 Z M56.7567568,19.3548387 L58.6486486,19.3548387 L58.6486486,25.1612903 L56.7567568,25.1612903 L56.7567568,19.3548387 Z M37.8378378,58.0645161 L43.5135135,58.0645161 L43.5135135,60 L37.8378378,60 L37.8378378,58.0645161 Z M28.3783784,58.0645161 L34.0540541,58.0645161 L34.0540541,60 L28.3783784,60 L28.3783784,58.0645161 Z M18.9189189,58.0645161 L24.5945946,58.0645161 L24.5945946,60 L18.9189189,60 L18.9189189,58.0645161 Z M47.2972973,9.67741935 L49.1891892,9.67741935 L49.1891892,11.6129032 L47.2972973,11.6129032 L47.2972973,9.67741935 Z M52.972973,44.9032258 L52.972973,40.2580645 L58.6486486,36.7741935 L64.3243243,40.2580645 L64.3243243,44.9032258 L70,44.9032258 L70,60 L60.932538,60 L60.9319046,51.8876953 L56.3786159,51.8876953 L56.3786159,60 L47.2972973,60 L47.2972973,44.9032258 L52.972973,44.9032258 Z M58.6494627,46.0645161 C59.9032984,46.0645161 60.919733,45.0246614 60.919733,43.7419355 C60.919733,42.4592096 59.9032984,41.4193548 58.6494627,41.4193548 C57.3956271,41.4193548 56.3791924,42.4592096 56.3791924,43.7419355 C56.3791924,45.0246614 57.3956271,46.0645161 58.6494627,46.0645161 Z M34.0540541,0 L45.4054054,8.51612903 L45.4054054,23.2258065 L36.3243243,23.2258065 L36.3243243,15.483871 L31.7837838,15.483871 L31.7837838,23.2258065 L22.7027027,23.2258065 L22.7027027,8.51612903 L34.0540541,0 Z M5.67567568,38.7096774 L15.1351351,38.7096774 L15.1351351,44.516129 L20.8108108,44.516129 L20.8108108,54.1935484 L15.1351351,54.1935484 L15.1351351,60 L5.67567568,60 L5.67567568,54.1935484 L0,54.1935484 L0,44.516129 L5.67567568,44.516129 L5.67567568,38.7096774 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb3a86c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/access_to_services.vue
// module id = 630
// module chunks = 1